import type { ActionCreatorWithoutPayload } from '@reduxjs/toolkit';
import { actionOnMessage } from '@skynet/data-ws-mm';

import { listen } from './actions';
import { initAccountsSlice } from './factory';
import { AccountCommands } from './types';

/**
 * Creates the MM-channel accounts reducer shared by loans and retainers (mount it at `accounts`).
 * It enters the loading state on an init {@link listen}. Which sections reload the accounts is
 * the app's routing knowledge, so the app filters them before it dispatches {@link listen}.
 *
 * @param resetAction - The app's global reset action.
 */
export function initSharedAccountsSlice(resetAction: ActionCreatorWithoutPayload) {
  return initAccountsSlice({
    sliceName: 'accounts',
    commands: AccountCommands,
    messages: actionOnMessage,
    resetAction,
    extraReducers: (builder) => {
      builder.addCase(listen, (state, action) => {
        if (action.meta.isInitCall) {
          state.requestStatus = 'pending';
        }
      });
    },
  });
}
